import { useEffect, useState } from "react";
import Modal from "../../UI/Modal";
import Table from "../../UI/Table";
import { companyKpiUseCase } from "../../../../di/container";
import type { ProductionLogEntry } from "../../../../domain/types/company/company-kpi";

interface Props {
  /** 클릭한 버킷 날짜 (yyyy-MM-dd). */
  date: string;
  /** 카드에서 선택한 장비(SPECIFIC)만 필터. ALL/미지정이면 전체. */
  machineIds?: number[];
  onClose: () => void;
}

/** 그래프 점 클릭 → 그 날의 워크로드 로그(장비별 증분/누적) 모달. */
export const WorkloadLogModal = ({ date, machineIds, onClose }: Props) => {
  const [logs, setLogs] = useState<ProductionLogEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const midKey = machineIds && machineIds.length ? machineIds.join(",") : "";

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await companyKpiUseCase.getProductionLogs(
          date,
          midKey ? midKey.split(",").map(Number) : undefined,
        );
        if (alive) setLogs(res.logs);
      } catch (e) {
        if (alive) setError(e instanceof Error ? e.message : "로그 조회 실패");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [date, midKey]);

  return (
    <Modal
      setIsModalVisible={() => onClose()}
      title={`워크로드 로그 · ${date}${logs.length ? ` (${logs.length}행)` : ""}`}
    >
      <div className="w-[640px] max-w-[calc(100vw-80px)] max-h-[70vh] overflow-y-auto">
        {loading ? (
          <div className="text-center text-gray-400 py-10 text-[13px]">불러오는 중…</div>
        ) : error ? (
          <div className="text-center text-[#F24A4A] py-10 text-[13px]">{error}</div>
        ) : logs.length === 0 ? (
          <div className="text-center text-gray-400 py-10 text-[13px]">
            해당 날짜의 워크로드 로그가 없습니다.
          </div>
        ) : (
          <Table
            tabledata={{
              head: [<>시각</>, <>장비</>, <>증분 생산수</>, <>금일 누적</>],
              body: logs.map((l) => [
                <>{l.time}</>,
                <>{l.machineName}</>,
                <>{l.incrementalCount}</>,
                <>{l.todayWorkloadCount}</>,
              ]),
            }}
          />
        )}
      </div>
    </Modal>
  );
};
